import { Component, inject } from '@angular/core';
import { NgbPopover, NgbDropdown, NgbDropdownToggle, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';
import { IccImportHistoryComponent } from '../icc-import-history/icc-import-history.component';
import { IccMedicaidCodeImportsService } from '../../../core/services/icc/icc-medicaid-code-imports.service';
import { ImportNavComponent } from '../../../shared/components/import-nav/import-nav.component';
import { DecimalPipe, TitleCasePipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PaginationHeaderComponent } from '../../../shared/components/pagination-header/pagination-header.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { PaginationComponent } from '../../../shared/components/pagination/pagination.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ClientSelectComponent } from '../../../shared/components/client-select/client-select.component';

@Component({
  selector: 'app-icc-import-medicaid-codes-history',
  templateUrl: '../icc-import-history/icc-import-history.component.html',
  imports: [ImportNavComponent,
    FormsModule,
    ClientSelectComponent,
    PaginationHeaderComponent,
    FaIconComponent,
    NgbPopover,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    PaginationComponent,
    MatProgressSpinner,
    DecimalPipe,
    TitleCasePipe,
    DatePipe]
})
export class IccImportMedicaidCodesHistoryComponent extends IccImportHistoryComponent {
  private medicaidCodeImportsService = inject(IccMedicaidCodeImportsService);

  pageTitle = 'Medicaid Code Import History';

  getImports(paging, filters) {
    return this.medicaidCodeImportsService.getList(paging, filters);
  }

  prepareImportResults(data) {
    return data.medicaidCodeImports;
  }

  getImport(importId) {
    return this.medicaidCodeImportsService.get(importId);
  }

  updateImport(importId, name) {
    return this.medicaidCodeImportsService.update(importId, name);
  }

  cancelImport(importId) {
    return this.medicaidCodeImportsService.cancel(importId);
  }
}
